import { API_BASE } from '../../lib/apiBase';

export default function AdminGames() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold font-display text-white">Games</h1>
      <div className="bg-slate-800 rounded-xl p-6">
        <p className="text-slate-400 text-sm">Games are powered by the Besitos API. Game inventory is fetched and cached every 10 minutes.</p>
        <div className="mt-4 space-y-2 text-sm text-slate-300">
          <p>Partner ID: {import.meta.env.VITE_BESITOS_PARTNER_ID ? 'Configured' : 'Not set'}</p>
          <p>Cache TTL: 10 minutes</p>
          <p>Postback endpoint: GET /api/postbacks/besitos</p>
        </div>
        <a
          href={`${API_BASE}/api/games/debug`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-4 text-sm text-primary hover:underline"
        >
          View debug endpoint →
        </a>
      </div>
    </div>
  );
}
